export default __webpack_public_path__ + "static/media/nullImg.eae143f4.png";